import axios from "axios";

class AuthService {
  login = async (payload) => {
    return await axios({
      method: "post",
      url: process.env.REACT_APP_AUTH_SERVER_URL,
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      auth: {
        username: payload.username,
        password: payload.password,
      },
    });
  };
}

export default new AuthService();
